<template>
  <div class="col-12">

    <div v-for="value in protocol.stages"  class="form-group row">

      <div class="col-12 mt-3">

        <h4 class="row-title" v-if="teachingMethod.id == 7">{{ value.description | trans }}</h4>

        <h4 class="row-title" v-if="teachingMethod.id == 8">
          
          {{'protocol.select_attempt' | trans}}
          
          <mdc-checkbox v-model="isAllTasksEnabled"/>
        </h4>

        <table class="table table-sm">
          <thead v-if="(isCurator || isBCBA) && protocol.assigneeId">
            <tr>
              <th></th>
              <th>{{'protocol.pecs.target_sequence_title' | trans}}</th>
              <th>{{'protocol.mastered_mand' | trans}}</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(task, index) in value.tasks" :key="task.id" v-if="(teachingMethod.id == 8 && isAllTasksEnabled && (task.position == 3 || task.position == 4)) || teachingMethod.id == 7 || (teachingMethod.id == 8 && !isAllTasksEnabled)">
              <td>
                {{index + 1}}
              </td>
              <td class="name-field">
                {{task.description}}
              </td>
              <td class="table-actions" v-if="(isCurator || isBCBA) && protocol.assigneeId">
                <mdc-checkbox v-model="task.mastered"/>
              </td>
            </tr>
          </tbody>
        </table>

      </div>

    </div>

    <div class="row mt-3">
      <div class="col-12">
        <div class="box-shadow">
          <div class="row">
            <div class="col-12">

              <div class="choose-block">
                <div class="mdc-radio-wrapper">
                  {{protocol.stages[0].masteringCondition.ratio}}{{'protocol.condition_procent' | trans }}
                  <input id="condition_session_mastering"
                         min=1
                         ref="condition_session_mastering"
                         class="ml-2"
                         type="number"
                         v-on:keydown="changeNumber"
                         name="condition_session_mastering"
                         v-model=protocol.stages[0].masteringCondition.sessionCount
                         v-validate="'required|min_value:1|max_value:10|numeric'"
                         data-vv-validate-on="none"
                         :data-vv-as="'protocol.condition_trial' | trans"/>
                  {{'protocol.condition_trial' | trans }}

                  <input id="condition_trial"
                         min=1
                         ref="condition_trial"
                         class="ml-2"
                         type="number"
                         v-on:keydown="changeNumber"
                         name="condition_trial"
                         v-model=protocol.stages[0].masteringCondition.trialCount
                         v-validate="'required|min_value:1|max_value:10|numeric'"
                         data-vv-validate-on="none"
                         :data-vv-as="'protocol.condition_session' | trans"/>

                  {{'protocol.condition_session' | trans }}

                </div>

                <span class="invalid-feedback invalid"
                      v-if="errors.has('condition_session_mastering')">
                              <strong>{{errors.first('condition_session_mastering')}} </strong>
                        </span>
                <span class="invalid-feedback invalid"
                      v-if="errors.has('condition_trial')">
                              <strong>{{errors.first('condition_trial')}} </strong>
                        </span>

              </div>

            </div>
          </div>

          <div class="row mt-3">
            <div class="col-md-12">
              <mdc-switch v-model="protocol.stages[0].isPromptEnabled">
                {{'protocol.track_change_level' | trans}}
              </mdc-switch>
              <hints :hint-list="protocol.stages[0].taskPrompts" :hintVisible="protocol.stages[0].isPromptEnabled"/>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
  import {mapGetters} from 'vuex';
  import Hints from '../../protocols/components/Hints';
  import map from 'lodash/map';
  import forEach from 'lodash/forEach';
  import filter from 'lodash/filter';

  export default {
    props: {
      'protocol': {
        type: Object
      },
      teachingMethod:{
        type: Object
      }

    },

    components: {Hints},

    data() {
      return {
        isAllTasksEnabled: false
      };
    },

    computed: {
      ...mapGetters('auth', [
        'isCurator',
        'isBCBA',
      ]),
    },

    inject: ["parentValidator"],

    created() {

      this.$validator = this.parentValidator;

      forEach(this.protocol.stages, stage => {

        stage.tasks = map(stage.tasks, (task) => {

          task.mastered = filter(stage.masteredTasks, function(item) {
            return item.globalUuid == task.globalUuid;
          }).length == 1;

          return task;

        });

      });

      this.isAllTasksEnabled = !this.protocol.isAllTasksEnabled


    },

    methods: {

      changeNumber(event){
        if (event.shiftKey || !((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105) || event.keyCode == 46 || event.keyCode == 8|| (event.keyCode >= 35 && event.keyCode <= 40) )) {
          event.preventDefault();
        }
      },

    },

    watch: {
      isAllTasksEnabled(newValue){

        this.protocol.isAllTasksEnabled = !newValue

      }
    }




  };
</script>



// WEBPACK FOOTER //
// src/modules/protocols/components/TasksPecs.vue